import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Button } from 'reactstrap';
import PlantManagementTable from './plantManagementTable.component';
import PlantModal from './plantModal.component';
import DeleteModal from './deleteModal.component';
import { IconPlus } from '@sfx/icons';
import { getPlantApi, getSubscriptionKeyApi } from '../../api';

var PlantManagement = /*#__PURE__*/function (_Component) {
  _inherits(PlantManagement, _Component);

  var _super = _createSuper(PlantManagement);

  function PlantManagement() {
    var _this;

    _classCallCheck(this, PlantManagement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      modalType: 'add',
      selectedPlant: {},
      isDeleteOpen: false,
      showLoading: true,
      plantList: []
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.setState = function () {
        return;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getMapKey", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getSubscriptionKeyApi().then(function (data) {
                localStorage.setItem('subscriptionKey', data.data);
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "getPlantList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                showLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return getPlantApi().then(function (data) {
                Array.isArray(data.data) && _this.setState({
                  plantList: data.data,
                  showLoading: false
                });
              });

            case 4:
              _context2.next = 10;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);

              if (_context2.t0 && _context2.t0.response && _context2.t0.response.status) {
                _this.setState({
                  plantList: []
                });
              }

              _this.setState({
                showLoading: false
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 6]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (modalType) {
      if (modalType) {
        _this.setState({
          modalType: modalType
        });
      }

      _this.setState({
        isOpen: !_this.state.isOpen
      }, function () {
        if (!_this.state.isOpen) {
          _this.setState({
            selectedPlant: {}
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEdit", function (selectedPlant) {
      _this.setState({
        selectedPlant: selectedPlant
      });

      _this.toggleModal('edit');
    });

    _defineProperty(_assertThisInitialized(_this), "handleDel", function (selectedPlant) {
      _this.setState({
        selectedPlant: selectedPlant
      });

      return _this.setState({
        isDeleteOpen: true
      });
    });

    return _this;
  }

  _createClass(PlantManagement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getPlantList();
      this.getMapKey();
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          prefix = _this$props.prefix,
          translate = _this$props.translate;
      var _this$state = this.state,
          plantList = _this$state.plantList,
          selectedPlant = _this$state.selectedPlant,
          isOpen = _this$state.isOpen,
          isDeleteOpen = _this$state.isDeleteOpen,
          showLoading = _this$state.showLoading;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-wrap ").concat(prefix, "-content-plant")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-wrap-option-handle single")
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        size: "sm",
        onClick: function onClick() {
          return _this2.toggleModal('add');
        }
      }, /*#__PURE__*/React.createElement(IconPlus, {
        size: "18"
      }), "\xA0", translate('SFxAccountSettingsAddPlantButtonText'))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-wrap-table")
      }, /*#__PURE__*/React.createElement(PlantManagementTable, {
        translate: translate,
        loading: showLoading,
        plantList: plantList,
        handleEdit: this.handleEdit,
        handleDel: this.handleDel,
        setSelectedPlant: function setSelectedPlant(selectedPlant) {
          _this2.setState({
            selectedPlant: selectedPlant
          });
        }
      })), isOpen && /*#__PURE__*/React.createElement(PlantModal, {
        translate: translate,
        prefix: prefix,
        isOpen: isOpen,
        toggle: this.toggleModal,
        modalType: this.state.modalType,
        plantList: plantList,
        selectedPlant: selectedPlant,
        refreshCallback: this.getPlantList
      }), /*#__PURE__*/React.createElement(DeleteModal, {
        translate: translate,
        prefix: prefix,
        isOpen: isDeleteOpen,
        toggle: function toggle() {
          _this2.setState({
            isDeleteOpen: !isDeleteOpen,
            selectedPlant: {}
          });
        },
        refreshCallback: this.getPlantList,
        selectedPlant: selectedPlant
      }));
    }
  }]);

  return PlantManagement;
}(Component);

export default PlantManagement;